import { render, staticRenderFns } from "./ChatSideBar.vue?vue&type=template&id=3a96cdfd&scoped=true&"
import script from "./ChatSideBar.vue?vue&type=script&lang=js&"
export * from "./ChatSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ChatSideBar.vue?vue&type=style&index=0&id=3a96cdfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96cdfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a96cdfd')) {
      api.createRecord('3a96cdfd', component.options)
    } else {
      api.reload('3a96cdfd', component.options)
    }
    module.hot.accept("./ChatSideBar.vue?vue&type=template&id=3a96cdfd&scoped=true&", function () {
      api.rerender('3a96cdfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatSideBar.vue"
export default component.exports